import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import { HomeLoading } from "@/components/home-loading.tsx";
import ReturnNav from "@/pages/(app)/returns/view/components/return-nav/return-nav.tsx";

export default function ReturnLayout() {
  return (
    <div className="relative w-full">
      <div className="flex flex-row flex-grow w-full">
        <div className="flex flex-col flex-1 w-full">
          <div className="flex xl:flex-row flex-col-reverse justify-center gap-4 py-32 items-start relative w-full">
            <div className="flex flex-col w-full xl:w-auto">
              <ReturnNav />
              <Suspense fallback={<HomeLoading />}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
